// Bulk / quantity pricing helpers shared by POS, Quotations and Inventory.
export function bulkTier(p, qty) {
  if (!p?.bulk_pricing_enabled || !Array.isArray(p.bulk_tiers)) return null;
  let best = null;
  for (const t of p.bulk_tiers) if (qty >= Number(t.min_qty) && (!best || Number(t.min_qty) > Number(best.min_qty))) best = t;
  return best;
}

// Re-resolve a cart/quote line's unit price from its base price and current quantity.
export function applyBulk(line) {
  const base = line.base_price ?? line.price;
  const t = bulkTier({ bulk_pricing_enabled: line.bulk_pricing_enabled, bulk_tiers: line.bulk_tiers }, line.quantity);
  return { ...line, base_price: base, price: t ? Number(t.price) : base, bulk_tier_min_qty: t ? Number(t.min_qty) : null };
}

export const lineFromProduct = (p) => ({ base_price: p.price, bulk_pricing_enabled: !!p.bulk_pricing_enabled, bulk_tiers: p.bulk_tiers || [] });
